export class LicenseValid {
  productType: string;
  grade: string;


  constructor(productType?: string, grade?: string) {
    this.productType = productType;
    this.grade = grade;
  }
}
